"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinsAi;
var _react = _interopRequireWildcard(require("react"));
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _collapsible = _interopRequireDefault(require("@ux/collapsible"));
var _SpinsAiButton = _interopRequireDefault(require("./SpinsAiButton"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _domainServices = require("@site/domain-services");
var _utils = require("@site/utils");
var _EidCodes = _interopRequireDefault(require("../EidCodes"));
var _SpinCardRecommendationsError = _interopRequireDefault(require("../SpinCard/SpinCardRecommendationsError"));
var _SpinCardRecommendationsContainer = _interopRequireDefault(require("../SpinCard/SpinCardRecommendationsContainer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SpinsAi({
  showAiDomains,
  setShowAiDomains = () => {},
  handleAiDomainSearchClick = () => {},
  plid,
  apiKey,
  urlOverride = '',
  domainToCheck = '',
  spinsAiTextId = 'ai.tryDomainSearchResults',
  ctaProps,
  options,
  enableDynamicFontScaling,
  PriceBlock,
  language,
  AddToCartButton,
  numberOfCards = 4,
  containerClasses = '',
  spinsAiButtonClassName,
  spinsAiButtonIconColor
}) {
  const [results, setResults] = (0, _react.useState)();
  const [isLoadingResults, setIsLoadingResults] = (0, _react.useState)(false);
  const {
    findSpinsPromise
  } = (0, _domainServices.initializeDomainServices)({
    apiKey,
    plid,
    urlOverride
  });
  const handleSpinsAiError = () => {
    (0, _utils.logImpression)(_EidCodes.default.Ai.Error);
    setIsLoadingResults(false);
  };
  const getAiResults = () => {
    setIsLoadingResults(true);
    const searchTerm = domainToCheck.trim().replace(/(\r\n|\r|\n)/g, '');
    const findApiCommonHeaders = (0, _domainServices.getFindApiHeaders)({
      referrer: document.referrer,
      isCypress: window.Cypress
    });
    (0, _utils.logEvent)({
      eid: _EidCodes.default.Ai.SpinsAiClick,
      type: 'click',
      properties: {
        searchTerm
      }
    });
    const spinsAiPromise = findSpinsPromise({
      query: searchTerm,
      extraParams: {
        intent: 'GenAI',
        pagesize: numberOfCards
      },
      options: {
        headers: findApiCommonHeaders
      }
    }).then(response => {
      return (0, _domainServices.commonResolve)(response);
    });
    Promise.all([spinsAiPromise]).then(([{
      data: spinsAiData
    }]) => {
      if (spinsAiData?.RecommendedDomains?.length > 0) {
        setResults(spinsAiData);
      } else {
        handleSpinsAiError();
      }
    }).catch(() => {
      handleSpinsAiError();
    });
  };
  (0, _react.useEffect)(() => {
    if (!results && !isLoadingResults && showAiDomains) {
      getAiResults();
    }
  }, [showAiDomains]);
  (0, _react.useEffect)(() => {
    if (results) setIsLoadingResults(false);
  }, [results]);
  const spinsAiContent = /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spins-ai",
    "data-testid": "spins-ai",
    className: (0, _classnames.default)('border-0 spins-ai', {
      expanded: showAiDomains
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dpp-results"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spin-results-wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-spins-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex justify-content-around modernize-spin align-items-center px-0 min-h-8', containerClasses)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spin-left-icon d-flex"
  }, /*#__PURE__*/_react.default.createElement(_sparklesFilled.default, {
    width: 24,
    height: 24,
    fill: "#613EA3"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "spins-domain-info spin-content spin-domain-dynamic-font-scaling"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: spinsAiTextId
  })), /*#__PURE__*/_react.default.createElement(_SpinsAiButton.default, {
    onClick: () => setShowAiDomains(true),
    disabled: showAiDomains,
    spinsAiButtonClassName: spinsAiButtonClassName,
    spinsAiButtonIconColor: spinsAiButtonIconColor
  }))))));
  return /*#__PURE__*/_react.default.createElement(_collapsible.default, {
    id: "spins-ai",
    title: spinsAiContent,
    className: (0, _classnames.default)('detailed-v-panel spin-expandable', {
      'border-radius-8 bd-gray bd-a-1 clicked': showAiDomains
    }),
    open: showAiDomains,
    onChange: isOpen => setShowAiDomains(isOpen)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spins-ai-content",
    "data-cy": "spins-ai-content",
    "data-testid": "spins-ai-content"
  }, !isLoadingResults && !results ? /*#__PURE__*/_react.default.createElement(_SpinCardRecommendationsError.default, {
    handleCardRecommendationsErrorClick: handleAiDomainSearchClick,
    dataCy: "spins-ai-error",
    dataTestId: "spins-ai-error",
    dataEid: _EidCodes.default.Ai.AiErrorLinkClick,
    messageIds: {
      title: 'ai.error',
      buttonText: 'ai.tryDomainSearch'
    }
  }) : /*#__PURE__*/_react.default.createElement(_SpinCardRecommendationsContainer.default, {
    numberOfCards: numberOfCards,
    results: results,
    ctaProps: ctaProps,
    options: options,
    enableDynamicFontScaling: enableDynamicFontScaling,
    PriceBlock: PriceBlock,
    language: language,
    AddToCartButton: AddToCartButton,
    isConversationalSearch: true,
    dataEid: _EidCodes.default.Ai.aiSearch
  })));
}
SpinsAi.propTypes = {
  showAiDomains: _propTypes.default.bool,
  setShowAiDomains: _propTypes.default.func,
  handleAiDomainSearchClick: _propTypes.default.func,
  plid: _propTypes.default.number,
  apiKey: _propTypes.default.string.isRequired,
  urlOverride: _propTypes.default.string,
  domainToCheck: _propTypes.default.string,
  spinsAiTextId: _propTypes.default.string,
  language: _propTypes.default.object,
  options: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  enableDynamicFontScaling: _propTypes.default.bool,
  ctaProps: _propTypes.default.object,
  numberOfCards: _propTypes.default.number,
  containerClasses: _propTypes.default.string,
  spinsAiButtonClassName: _propTypes.default.string,
  spinsAiButtonIconColor: _propTypes.default.string
};